export default {
  additionalFields: 'Дополнительные поля',
  basic: 'Основное',
  advanced: 'Расширенные',
  mobileApp: 'Мобильное приложение',
  print: 'Печать',
  printProps: {
    printOrientation: {
      label: 'Ориентация страницы',
      info: 'Ориентация, используемая когда эта сущность начинает свою собственную печатную секцию. По умолчанию наследуется ориентация документа, выбранная при экспорте.',
    },
    orientations: {
      default: 'По умолчанию (документ)',
      portrait: 'Портретная',
      landscape: 'Альбомная',
    },
  },
  validations: 'Проверки',
  function: 'Функция',
  editingFunction: 'Редактирование функции {{functionName}}',
  editorHelp: {
    json: 'Допустимые выражения являются подмножеством Javascript.',
    sql: 'Разрешены только допустимые SQL-выражения.',
  },
  editorCompletionHelp: '- Показать доступные переменные и функции, которые можно использовать',
  functionDescriptions: {
    categoryItemProp: 'Возвращает значение указанного $t(extraProp.label) элемента категории с указанным кодом',
    dateTimeDiff: 'Возвращает разницу (в минутах) между двумя парами дата-время',
    distance: 'Возвращает расстояние (в метрах) между указанными координатами',
    geoCoordinateAtDistance: 'Возвращает координаты на указанном расстоянии и азимуте от указанных координат',
    geoDistance: '$t(nodeDefEdit:functionDescriptions.distance)',
    first: 'Возвращает первое значение или узел указанного множественного атрибута или сущности',
    geoPolygon: 'Генерирует полигон в GeoJSON из списка координат',
    includes: 'Возвращает true, если указанный множественный атрибут включает указанное значение.',
    index: 'Возвращает индекс указанного узла среди его братьев',
    isEmpty: 'Возвращает true, если для аргумента не указано значение',
    isNotEmpty: 'Возвращает true, если для аргумента указано некоторое значение',
    last: 'Возвращает последнее значение или узел указанного множественного атрибута или сущности',
    ln: 'Возвращает натуральный логарифм X',
    log10: 'Возвращает логарифм X по основанию 10',
    max: 'Возвращает максимум из аргументов',
    min: 'Возвращает минимум из аргументов',
    now: 'Возвращает текущую дату или время',
    parent: 'Возвращает родительскую сущность указанного узла',
    pow: 'Возвращает значение основания, возведенного в степень',
    prevCycleNote:
      'Работает только в Arena Mobile, если определены несколько циклов и включена ссылка на предыдущий цикл',
    prevCycleValue:
      'Возвращает значение того же атрибута в записи предыдущего цикла. $t(nodeDefEdit:functionDescriptions.prevCycleNote)',
    prevCycleValues:
      'Возвращает значения тех же атрибутов в записи предыдущего цикла. $t(nodeDefEdit:functionDescriptions.prevCycleNote)',
    recordCycle: 'Возвращает цикл текущей записи',
    recordDateCreated:
      'Возвращает дату и время создания текущей записи в виде значения datetime. Может использоваться в текстовом, датовом или временном атрибуте',
    recordDateLastModified:
      'Возвращает дату и время последнего изменения текущей записи в виде значения datetime. Может использоваться в текстовом, датовом или временном атрибуте',
    recordOwnerEmail: 'Возвращает email пользователя, которому принадлежит запись',
    recordOwnerName: 'Возвращает имя пользователя, которому принадлежит запись',
    recordOwnerRole: 'Возвращает роль (в текущем опросе) пользователя, которому принадлежит запись',
    rowIndex: 'Возвращает текущий индекс строки таблицы (или формы)',
    taxonProp: 'Возвращает значение указанного $t(extraProp.label) таксона с указанным кодом',
    taxonVernacularName:
      'Возвращает (первое) народное (или местное) название на указанном языке таксона с указанным кодом',
    unique: 'Возвращает уникальные значения множественного атрибута или сущности',
    userEmail: 'Возвращает email вошедшего в систему пользователя',
    userIsRecordOwner:
      'Возвращает логическое значение "true", если пользователь, редактирующий запись, также является ее владельцем, "false" в противном случае',
    userName: 'Возвращает имя вошедшего в систему пользователя',
    userProp: 'Возвращает значение указанного $t(extraProp.label) вошедшего в систему пользователя',
    uuid: 'Генерирует UUID (универсальный уникальный идентификатор), который может быть использован в качестве идентификатора (например, в качестве ключевого атрибута сущности)',
    // SQL functions
    avg: 'Возвращает среднее значение числовой переменной',
    count: 'Возвращает количество строк, соответствующих указанному критерию',
    sum: 'Возвращает общую сумму числовой переменной',
  },
  functionName: {
    rowIndex: 'Индекс строки',
  },
  basicProps: {
    analysis: 'Анализ',
    autoIncrementalKey: {
      label: 'Автоинкрементный ключ',
      info: 'Значение будет генерироваться автоматически',
    },
    autoCreateMinCountItems: {
      label: 'Автосоздание минимального количества элементов',
      info: 'Когда сущность становится актуальной или создается ее родительская сущность, автоматически создается количество сущностей, равное минимальному значению.',
    },
    displayAs: 'Отображать как',
    displayIn: 'Отображать в',
    entitySource: 'Источник сущности',
    enumerate: {
      label: 'Перечислить',
      info: `Строки будут автоматически генерироваться с использованием элементов категории, связанных с атрибутом кода, помеченным как Ключ, определенный внутри сущности; строки нельзя добавлять или удалять, а атрибут кода ключа не будет редактируемым`,
    },
    enumeratingItemsExpression: {
      label: 'Выражение для перечисляемых элементов',
      info: 'Необязательное выражение, которое определяет, какие элементы категории перечисляются (например, unique(table_source.source_type)). Если оно пустое, используются все элементы категории.',
    },
    enumerator: {
      label: 'Перечислитель',
      info: 'Элементы в категории будут использоваться для генерации строк родительской сущности',
    },
    form: 'Форма',
    formula: 'Формула',
    includedInClonedData: 'Включено в клонированные данные',
    includedInMultipleEntitySummary: {
      label: 'Включить в сводку множественной сущности',
      info: `Если отмечено, значение атрибута будет отображаться в списке выбора сущности и в представлении сводки сущности`,
    },
    includedInRecordsList: {
      label: 'Включить в список записей',
      info: `Если отмечено, атрибут будет виден в списке записей`,
    },
    key: 'Ключ',
    maxKeysCountReached: 'Достигнуто максимальное количество ключей ({{maxKeysCount}})',
    multiple: 'Множественный',
    ownPage: 'Собственная страница',
    parentPage: 'Родительская страница ({{parentPage}})',
    qualifier: {
      label: 'Квалификатор',
      info: `Когда пользователь, принадлежащий к группе, создаёт новую запись, этот атрибут будет автоматически заполнен значением, указанным для него в квалификаторах группы пользователя. Пользователи смогут видеть и изменять только записи, принадлежащие их собственной группе, если они входят в какую-либо группу.`,
    },
    table: 'Таблица',
  },
  advancedProps: {
    defaultValuesNotSpecified: 'Значения по умолчанию не указаны',
    defaultValuesSpecified: 'Значения по умолчанию указаны',
    editableAlways: 'Всегда редактируемо',
    editableIfConditionIsMet: 'Редактируемо при выполнении условия',
    relevantIfRadioNone: 'Всегда актуально',
    relevantIfRadioDefined: 'Актуально при выполнении условия',
    visibleAlways: 'Всегда видимо',
    visibleIfConditionIsMet: 'Видимо при выполнении условия',
    areaBasedEstimate: 'Оценка по площади',
    defaultValues: 'Значения по умолчанию',
    defaultValuesInfo: `Это позволяет автоматически заполнять ответ по заданным правилам.
    Если настроено несколько правил, система проверит их по порядку сверху вниз.
    Будет применено первое правило, которое подходит под условия, и его результат станет ответом.`,
    defaultValueEvaluatedOneTime: 'Значение по умолчанию оценивается только один раз',
    defaultValueEvaluatedOneTimeInfo: `Значение по умолчанию будет вычисляться только один раз, при создании атрибута.
    Если флажок не установлен, значение по умолчанию будет пересчитываться при каждом обновлении записи.
    Это следует отмечать при использовании выражений вроде now() или uuid(), которые должны вычисляться только один раз, при первом формировании значения атрибута.`,
    defaultValuesNotEditableForAutoIncrementalKey:
      'Значения по умолчанию нередактируемы, так как установлен автоинкрементный ключ',
    editableIf: 'Редактируемо, если',
    editableIfInfo: `По умолчанию пользователь всегда может работать с релевантным полем.
Здесь можно задать правило, определяющее, может ли пользователь вводить или изменять значение этого поля.
Это определяет, может ли пользователь вводить или менять значение в этом поле.
Если заданные условия выполняются, поле можно редактировать. Иначе оно становится только для чтения (заблокировано).`,
    hidden: 'Всегда скрыто',
    hiddenInReport: 'Скрыть в аналитической панели',
    hiddenInReportInfo: `Если отмечено, атрибут не будет виден в аналитической панели`,
    hiddenWhenNotRelevant: 'Скрыто, когда неактуально',
    itemsFilter: 'Фильтр элементов',
    itemsFilterInfo: `Выражение, используемое для фильтрации выбираемых элементов.
В выражении слово "this" будет относиться к самому элементу.
Например: this.region = region_attribute_name
(где "region" - это имя дополнительного свойства, определенного для элемента, а region_attribute_name - это имя атрибута в опросе)`,
    readOnly: 'Только для чтения',
    relevantIf: 'Актуально, если',
    relevantIfInfo: `По умолчанию все поля активны.
    Если вы зададите правило актуальности и оно не выполнится, поле станет серым или полностью скроется,
    а автоматические ответы будут игнорироваться.
    Используйте это, чтобы динамически показывать или скрывать части формы; например, показывать поле «Уточните», только если пользователь выбрал «Другое».`,
    script: 'Скрипт',
    visibleIf: 'Видимо, если',
    visibleIfInfo: `По умолчанию поле всегда видно.
    Если задать правило, поле будет видно только когда это правило выполняется; иначе оно будет скрыто.
    Важно: в отличие от скрытия «неактуального» поля, скрытое поле все равно может сохранять автоматический ответ.
    Это удобно для сокрытия целых разделов формы в зависимости от того, кто вошел в систему (например, по роли).`,
  },
  mobileAppProps: {
    hiddenInMobile: {
      label: 'Скрыто в Arena Mobile',
      info: `Если отмечено, атрибут не будет виден в AM`,
    },
    includedInPreviousCycleLink: {
      label: 'Включить в ссылку на предыдущий цикл',
      info: `Если отмечено, значение из предыдущего цикла будет отображаться в форме ввода данных (когда ссылка на предыдущий цикл активна в мобильном приложении)"`,
    },
  },
  numericProps: {
    unit: 'Единица',
  },
  decimalProps: {
    maxNumberDecimalDigits: 'Максимальное количество десятичных знаков',
  },
  fileProps: {
    fileNameExpression: 'Выражение имени файла',
    fileType: 'Тип файла',
    fileTypes: {
      image: 'Изображение',
      video: 'Видео',
      audio: 'Аудио',
      other: 'Другое',
    },
    maxFileSize: 'Макс. размер файла (МБ)',
    numberOfFiles: 'Перейдите в раздел "Проверки", чтобы изменить минимальное и максимальное количество файлов.',
    showGeotagInformation: 'Показать информацию о геотегах',
  },
  mobileProps: {
    title: 'Мобильное приложение',
  },
  timeProps: {
    includeSeconds: 'Включить секунды',
  },
  formHeaderProps: {
    headerColorLabel: 'Цвет заголовка',
    headerColor: {
      blue: 'Синий',
      green: 'Зеленый',
      orange: 'Оранжевый',
      red: 'Красный',
      yellow: 'Желтый',
    },
  },
  textProps: {
    displayAsTypes: {
      hyperlink: 'Гиперссылка',
      markdown: 'Markdown',
      text: 'Текст',
    },
    textInputType: 'Тип текстового ввода',
    textInputTypes: {
      singleLine: 'Одна строка',
      multiLine: 'Многострочный',
    },
    textTransform: 'Преобразование текста',
    textTransformTypes: {
      none: 'нет',
      capitalize: 'с большой буквы',
      uppercase: 'в верхний регистр',
      lowercase: 'в нижний регистр',
    },
  },
  booleanProps: {
    labelValue: 'Значение метки',
    labelValues: {
      trueFalse: '$t(common.true)/$t(common.false)',
      yesNo: '$t(common.yes)/$t(common.no)',
    },
  },
  codeProps: {
    category: 'Категория',
    codeShown: 'Показать код',
    displayAsTypes: {
      checkbox: 'Флажок',
      dropdown: 'Выпадающий список',
    },
    parentCode: 'Родительский код',
  },
  coordinateProps: {
    allowOnlyDeviceCoordinate: 'Разрешить только координаты устройства',
    allowOnlyDeviceCoordinateInfo: `Применяется только к Arena Mobile: если отмечено, пользователь не сможет изменять значения X/Y, но для их получения можно будет использовать только GPS устройства`,
    mapMarkerColor: 'Цвет маркера на карте',
  },
  expressionsProp: {
    expression: 'Выражение',
    applyIf: 'Применить, если',
    confirmDelete: 'Удалить это выражение?',
    severity: 'Важность',
  },
  validationsProps: {
    minCount: 'Минимальное количество',
    maxCount: 'Максимальное количество',
    expressions: 'Выражения валидации',
    attributeAlwaysValid: 'Атрибут всегда корректен',
    attributeValidWhenConditionIsMet: 'Атрибут корректен при выполнении условия',
    notRequired: 'Не обязательно',
    alwaysRequired: 'Всегда обязательно',
    requiredWhenConditionIsMet: 'Обязательно при выполнении условия',
  },
  cannotChangeIntoMultipleWithDefaultValues:
    'Этот узел не может быть преобразован в множественный, потому что у него есть значения по умолчанию.',
  cannotDeleteNodeDefReferenced: `Невозможно удалить "{{nodeDef}}": на него ссылаются следующие определения узлов: {{nodeDefDependents}}`,
  cloneDialog: {
    confirmButtonLabel: 'Клонировать',
    title: 'Клонирование определения узла "{{nodeDefName}}"',
    entitySelectLabel: 'Сущность для клонирования:',
  },
  conversion: {
    dialogTitle: 'Преобразовать {{nodeDefName}} в другой тип',
    fromType: 'Из типа',
    toType: 'В тип',
  },
  moveDialog: {
    confirmButtonLabel: 'Переместить',
    title: 'Перемещение определения узла "{{nodeDefName}}" из "{{parentNodeDefName}}"',
    entitySelectLabel: 'Сущность, в которую нужно переместить:',
  },
  movedNodeDefinitionHasErrors:
    'Определение узла "{{nodeDefName}}", которое вы переместили, содержит ошибки; пожалуйста, исправьте их.',
  nodeDefintionsHaveErrors: 'Эти определения узлов содержат ошибки: {{nodeDefNames}}. Пожалуйста, исправьте их.',
  filterVariable: 'Переменная для фильтрации элементов',
  filterVariableForLevel: 'Переменная для {{levelName}}',
  unique: {
    label: 'Уникальный',
    info: `Когда атрибут помечен как **Уникальный**, его значение должно быть уникальным внутри ближайшей множественной сущности (иначе будет показана ошибка).

---

Например, в структуре *кластер -> участок -> дерево*, если у вас есть атрибут *tree_species*, помеченный как **Уникальный**, вы можете иметь только одно дерево каждого вида внутри одного и того же *участка*.`,
  },
  nodeDefClonedSuccessfully: 'Определение узла "{{nodeDefName}}" успешно клонировано в "{{targetParentNodeDefName}}"',
  categoriesClonedFromSurvey: 'Следующие категории также были клонированы из исходного опроса: {{names}}',
  taxonomiesClonedFromSurvey: 'Следующие таксономии также были клонированы из исходного опроса: {{names}}',
}
